import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import HomeHeader from "./home-header/home-header";
import Hero from "./hero/hero";
import TestsWeOffer from "./tests-we-offer/tests-we-offer";
import ExploreTests from "./explore-tests/explore-tests";
import HowItWorks from "./how-it-works/how-it-works";
import WhyChooseUs from "./why-choose-us/why-choose-us";
import RealStories from "./real-stories/real-stories";
import TakeControl from "./take-control/take-control";
import HomeFooter from "./home-footer/home-footer";
import "./homepage.css";
import LazyBackground from "../Lazy/lazy-background";

const Homepage = () => {
  const { hash } = useLocation(); // Get the hash from the URL

  // This effect runs when the component mounts or the hash changes
  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        // Use a small timeout to ensure all components have rendered in the DOM
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 150);
      }
    }
  }, [hash]); // The effect depends on the hash value

  return (
    <motion.div
      className="homepage-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <LazyBackground
        src={`${process.env.PUBLIC_URL}/assets/background.svg`}
        alt=""
        className="home-background home-background1"
        loading="lazy"
      />
      <HomeHeader />
      <main>
        <Hero />
        <TestsWeOffer />
        <ExploreTests />
        <HowItWorks />
        <WhyChooseUs />
        <RealStories />
        <TakeControl />
      </main>
      <HomeFooter />
    </motion.div>
  );
};

export default Homepage;